import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators,FormBuilder } from '@angular/forms';
import { AppSettings } from './../../../app.constant';
import { UserService } from './../../../shared/services/user.service';
import { RoleService } from './../../../shared/services/role.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  profileForm:FormGroup;
  users:any;
  errorMessage:any;
  PK_UserID:any;
  post:any;
  profile:any;
  roles:any;
  FK_RoleID:any=null;
  UserName:any=null;
  Password:any=null;
  FirstName:any=null;
  LastName:any=null;
  

  constructor(private FormBuilder:FormBuilder,
              private _userService:UserService,
              private _roleService:RoleService) { }

  ngOnInit() {
    this.profileForm = this.FormBuilder.group({
      'PK_UserID':['', ],
      'FK_RoleID':['', ],
      'UserName':['', Validators.required],
      'Password':['', [Validators.required, Validators.maxLength(10)]],
      'FirstName':['', [Validators.required, Validators.maxLength(250)]],
      'LastName':['', [Validators.required, Validators.maxLength(250)]] 
    })

    this.getAllUser();
    this. getAllRoles();
  }

  getAllUser() :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
      // this.post=JSON.stringify();
      // console.log(this.post);
       this._userService.getAllUsers(AppSettings.API_ENDPOINT+AppSettings.GetAllUsers).subscribe(
      data =>
         {
           this.users=data;
      },
      error => this.errorMessage = <any>error)
  }

  getAllRoles() :void  {
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.loginForm.value))
      // this.post=JSON.stringify();
      // console.log(this.post);
       this._roleService.getAllRole(AppSettings.API_ENDPOINT+AppSettings.GetAllRole).subscribe(
      data =>
         {
           this.roles=data;
      },
      error => this.errorMessage = <any>error)
  }

  getUserByID(PK_UserID) :void {
   
    this.PK_UserID=PK_UserID;
    var o={
          PK_UserID:PK_UserID
          }
    this.post=JSON.stringify(o);
    this._userService.getUserData(AppSettings.API_ENDPOINT+AppSettings.GetUserByID, this.post).subscribe(
        data => {
                this.profile=data;
                this.FirstName=this.profile[0].FirstName;
                this.LastName=this.profile[0].LastName;
                this.UserName=this.profile[0].UserName;
                this.Password=this.profile[0].Password;
                this.FK_RoleID=this.profile[0].FK_RoleID;
                // this.students= this.student.filter((item) => item.FK_ProgramID == PK_ProgramID);
   },
    error => this.errorMessage = <any>error)
  }


//   createUser(post) :void  {
//     this.submitted=true;
//     if (this.profileForm.invalid) {  return;  }
//     this.post=JSON.stringify(post);
//     this._userservice.postGrade(AppSettings.API_ENDPOINT+AppSettings.CreateGrade,this.post).subscribe(
//     data =>{   
//       this.httpResponseMessage=data
//       this.openSnackBar(this.httpResponseMessage,'');
//       this.gradeForm.reset();
//     },
//     error => this.errorMessage = <any>error)
// }


//   updateUser(post)  {
//     if (this.gradeForm.invalid) {  return;  }
//     this.post=JSON.stringify(post);
//     this._gradeservice.updateGrade(AppSettings.API_ENDPOINT+AppSettings.UpdateGrade,this.post).subscribe(
//       data =>{   
//         this.httpResponseMessage=data
//         this.openSnackBar(this.httpResponseMessage,'');
//         this.gradeForm.reset();
//       },
//       error => this.errorMessage = <any>error)
//   }

}
